import {
  Switch,
  Grid,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface StateSwitchProps {
  value: boolean;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    newValue: boolean
  ) => void;
  labelOn: string;
  labelOff: string;
}

const StateSwitch: React.FC<StateSwitchProps> = ({
  value,
  onChange,
  labelOn,
  labelOff
}) => {
  const { t } = useTranslation();

  const theme = useTheme();
  const biggerScreen = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Grid
      container
      alignItems="center"
      justifyContent={{ xs: 'center', sm: 'flex-end' }}
    >
      <Grid item>
        <Typography variant={biggerScreen ? 'subtitle1' : 'subtitle2'}>
          {t(labelOff)}
        </Typography>
      </Grid>
      <Grid item>
        <Switch checked={value} onChange={onChange} />
      </Grid>
      <Grid item>
        <Typography variant={biggerScreen ? 'subtitle1' : 'subtitle2'}>
          {t(labelOn)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default StateSwitch;
